import CircleIcon from '@mui/icons-material/Circle';
import { Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import moment from 'moment';
import React, { memo, useMemo } from 'react';
import theme from '../../../../../theme';
import { Dashboard, EmailBody } from '../../../../../types/files';
import ArrayUtils from '../../../../../utils/ArrayUtils';
import useStyles from "../styles";

const RecentItem: React.FC<{
    iconColor: string;
    label: string;
    timestamp: string | Date | null | undefined;
}> = ({ iconColor, label, timestamp }) => {
    const classes = useStyles();

    return (
        <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" width="100%">
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <CircleIcon sx={{ width: 12, height: 12, fill: iconColor }} />
                <Typography className={classes.label}
                    fontWeight="600 !important"
                    color={`${theme.colors.neutral['700']} !important`}>
                    {label}
                </Typography>
            </Stack>
            <Typography className={classnames(classes.label, classes.sublabel)}
                color={`${theme.colors.neutral['600']} !important`} pl={2}>
                {moment(timestamp).fromNow()}
            </Typography>
        </Stack>
    );
};

const RecentCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const emailItems: EmailBody[] = useMemo(() =>
        ArrayUtils.sortByDescending([...dashboard?.emailBodies
            ?.filter(emailBody => ['NEW_DEAL', 'COMPANY_UPDATE', 'NEW_FUND_OPPORTUNITY', 'FUND_PORTFOLIO_UPDATE'].includes(emailBody?.contentClassification || '')) || []], 'createdAt')
    , [dashboard?.emailBodies]);

    const classification = emailItems?.[0]?.contentClassification;

    let iconColor: string;
    let label: string;
    let timestamp: string | Date | null | undefined;

    switch (classification) {
        case 'COMPANY_UPDATE':
            iconColor = theme.colors.warning['400'];
            label = 'Company update';
            timestamp = emailItems?.[0]?.createdAt;
            break;
        case 'NEW_FUND_OPPORTUNITY':
            iconColor = '#12b981';
            label = 'New fund opportunity';
            timestamp = emailItems?.[0]?.createdAt || dashboard.createdAt;
            break;
        case 'FUND_PORTFOLIO_UPDATE':
            iconColor = theme.colors.violet['600'];
            label = 'Fund portfolio update';
            timestamp = emailItems?.[0]?.createdAt || dashboard.createdAt;
            break;
        case 'NEW_DEAL':
        default:
            iconColor = theme.colors.blue['600'];
            label = 'New deal';
            timestamp = dashboard.createdAt;
            break;
    }

    return (
        <RecentItem
            iconColor={iconColor}
            label={label}
            timestamp={timestamp}
        />
    );
}

export default memo(RecentCell);
